module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_ceo.ver2_0_2.png?1ba6f1b2";